import {
    ZtButtonConfig,
    ZtButtonType,
} from 'src/app/shared/components/atoms/zt-button/zt-button.model';

export interface ZtTableRow {
    data: any;
}

export interface ZtTableAction {
    action: Function;
    btnConfig: ZtButtonConfig;
    btnType: ZtButtonType;
    name: string;
}

export enum ZtTableHeaderType {
    ACTIONS = 'actions',
    AUDIO = 'audio',
    BUTTON = 'button',
    CONTROL = 'control',
    DATE = 'date',
    NUMBER = 'number',
    NUMBER_VARIANTS = 'number-variants',
    STRING = 'string',
    STRING_VARIANTS = 'string-variants',
}

export interface ZtTableHeaderInfo {
    headerName: string;
    key: string;
    type: ZtTableHeaderType;
    tooltip?: string;
    shouldConcat?: boolean;
    widthPercentage?: number;
    sortable?: boolean;
    filterable?: boolean;
}

export enum ZtTableSortOrder {
    ASC,
    DESC,
}

export interface ZtTableFilterConfig {
    column: string;
    value: string;
}

export interface ZtTableFilteredItem {
    data: any;
    type: ZtTableHeaderType;
}
